import { ENTITY_API_URL } from "../environment";
import { initAxiosFor } from "../security/axiosUtils";

export function useEntityTypesService() {
  const axiosInstance = initAxiosFor(ENTITY_API_URL);
  return {
    import: async (sourceTenantId: string, targetTenantId: string) => 
      (await axiosInstance.get(`${ENTITY_API_URL}/api/termoobjecttypes/copy-from/${sourceTenantId}/to/${targetTenantId}`))?.data,
  }
}